(function () {
    'use strict';

    angular.module("imApp").factory("stockOnLocationService", ['$ihttp', function ($ihttp) {
        let service = {
            getStockOnLocation: function (parms) {
                return $ihttp.post({
                    method: 458,
                    parameters: parms || {}
                });
            },
            listStockOnLocations: function (parms) {
                return $ihttp.post({
                    method: 459,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
